import React, { useEffect, useState } from "react";
import { getDataFromLocalStorage } from "../util/localStorage";
import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import ErrorPopUpComponent from "./ErrorPopUpComponent";
import fullscreen from "../images/fullscreen.svg";
import exitFullScreenIcon from "../images/exitFullScreenIcon.svg";
const PdfView = ({ onToggleFullScreen, fullscreenPanel }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isMessageShow, setIsMessageShow] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      (async () => {
        await fetchSignedUrl();
      })();
    }
  }, [id]);

  const fetchSignedUrl = async () => {
    setIsMessageShow(false);
    setErrorMessage("");

    const docList = getDataFromLocalStorage("documentList");
    // console.log("docList====", docList);
    if (!Array.isArray(docList)) {
      // console.log("docList", docList);
      // console.error("documentList is not an array or is null/undefined.");
      setErrorMessage("Document list not found or invalid.");
      setIsMessageShow(true);
      return;
    }

    // Find the document with the matching ID
    const currentDoc = docList.find((item) => item.id == id);
    if (!currentDoc || !currentDoc.s3_key) {
      console.error("Document not found or missing s3_key.");
      setErrorMessage("Document not found or missing file details.");
      setIsMessageShow(true);
      return;
    }

    const token = await getDataFromLocalStorage("token");
    const url = `${baseUrl + AI_PDF_CONST.API_ENDPOINT.GET_SIGNED_URL}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ s3_key: currentDoc.s3_key }),
      });

      if (response.status === 200) {
        const result = await response.json();
        if (result?.data?.signed_url) {
          const { signed_url } = result.data;
          //   console.log("Signed URL:", signed_url);
          await fetchPdfBlob(signed_url);
        } else {
          console.error("Signed URL not found in response.");
          setErrorMessage("Failed to retrieve signed URL.");
          setIsMessageShow(true);
        }
      } else {
        console.error("Failed to fetch signed URL:", response.statusText);
        setErrorMessage("Failed to fetch signed URL.");
        setIsMessageShow(true);
      }
    } catch (error) {
      console.error("Error fetching signed URL:", error);
      setErrorMessage("Unexpected error while fetching signed URL.");
      setIsMessageShow(true);
    }
  };

  const fetchPdfBlob = async (signed_url) => {
    try {
      const response = await fetch(signed_url);
      if (response.status === 200) {
        const pdfData = await response.arrayBuffer();
        const pdfBlob = new Blob([pdfData], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfUrl(pdfUrl); // Set the PDF URL for rendering
      } else {
        console.error("Failed to load PDF from signed URL");
        setErrorMessage("Failed to load the document.");
        setIsMessageShow(true);
      }
    } catch (error) {
      console.error("Error fetching PDF:", error);
      setErrorMessage("Unexpected error.");
      setIsMessageShow(true);
    }
  };
  console.log("fullscreenPanel", fullscreenPanel);
  return (
    <div className="w-full relative min-h-[calc(100vh-70px)]">
      <button
        className="absolute fullScreenIcon right-[124px] top-[21px] rounded"
        onClick={onToggleFullScreen}
        title="View full screen"
      >
        {fullscreenPanel === "pdf" ? (
          <img
            alt="Full Screen"
            src={exitFullScreenIcon}
            className="w-[18px] -mt-[2px]"
          />
        ) : (
          <img alt="Full Screen" src={fullscreen} className="w-[13px]" />
        )}
      </button>
      {pdfUrl ? (
        // <object
        //   className="w-full h-full pdfCol min-h-[450px]"
        //   data={pdfUrl} // Use the dynamically created PDF blob URL
        //   type="application/pdf"
        //   onError={() => {
        //     console.error("Error loading PDF");
        //   }}
        // />
        <iframe
          className="w-full h-full iframHeight"
          src={pdfUrl} // Use the dynamically created PDF blob URL
          title="PDF Document"
          frameBorder="0"
          onError={() => {
            console.error("Error loading PDF");
          }}
        />
      ) : (
        <div className="loaderingView">
          <div className="loaderPdf">
            <Loader />
          </div>
        </div>
      )}
      <ErrorPopUpComponent
        isErrorShow={isMessageShow}
        errorMessage={errorMessage}
        redirect="/dashboard"
      />
    </div>
  );
};

export default PdfView;
